import {
    activateUser,
    checkVersion,
    createLoginLink,
    loadUser,
    requestNewAccount,
    requestNewLink,
    sendSlackNotification,
} from '../repositories/HomeRepository'

const useHome = () => {
    const handleCheckVersion = onSuccess => {
        return checkVersion().then(onSuccess)
    }

    const handleActivateUser = (
        userInfo,
        userId,
        email,
        onSuccess,
        onError,
    ) => {
        return activateUser({
            ...userInfo,
            userId: userId,
            email: email,
        })
            .then(onSuccess)
            .catch(onError)
    }

    const handleLoadUser = (userId, onLoaded, onError) => {
        return loadUser(userId)
            .then(response => {
                if (response?.data?.success === false) {
                    onError({ response })
                    return
                }

                onLoaded(response)
            })
            .catch(onError)
    }

    const handleCreateLoginLink = (formValues, onSended, onError) => {
        return createLoginLink(formValues)
            .then(onSended)
            .catch(onError)
    }

    const handleRequestNewAccount = (values, onRequested, onError) => {
        return requestNewAccount(values)
            .then(onRequested)
            .catch(onError)
    }

    const handleRequestNewLink = (uid, onRequested, onError) => {
        return requestNewLink(uid)
            .then(onRequested)
            .catch(onError)
    }

    const handleSendNotification = (data, onSuccess, onError) => {
        return sendSlackNotification(data)
            .then(onSuccess)
            .catch(onError)
    }

    return {
        handleCheckVersion,
        handleActivateUser,
        handleLoadUser,
        handleCreateLoginLink,
        handleRequestNewAccount,
        handleRequestNewLink,
        handleSendNotification,
    }
}

export default useHome
